import { SectionHeader } from "@/components/ui/SectionHeader";
import { StatusPipeline, type StatusNode } from "@/components/ui/StatusPipeline";

const INTENT_NODES: StatusNode[] = [
  { code: "PENDING_DEPOSIT", label: "入金待ち" },
  { code: "DEPOSITED", label: "入金確認済み" },
  { code: "COMPLETED", label: "ステーブルコイン 送金完了" },
  { code: "FAILED", label: "失敗", terminal: true },
];

const REDEMPTION_NODES: StatusNode[] = [
  { code: "Requested", label: "申請済み" },
  { code: "CryptoDetected", label: "ステーブルコイン 入金検知" },
  { code: "CryptoConfirmed", label: "ステーブルコイン 入金確定" },
  { code: "FiatPayoutProcessing", label: "JPY 払戻処理中" },
  { code: "Completed", label: "完了" },
  { code: "Failed / OnHold", label: "失敗・保留", terminal: true },
];

export function MbscStatusLifecycle() {
  return (
    <section className="px-6 py-20 md:px-12">
      <div className="mx-auto max-w-4xl">
        <SectionHeader
          eyebrow="Status Lifecycle"
          title="透明な状態遷移で、すべてを追跡。"
          description="Intent（日本円→ステーブルコイン）と Redemption（ステーブルコイン→日本円）はそれぞれ明確なステータスで管理されます。各遷移は API レスポンスで取得でき、リアルタイムに追跡可能です。"
        />

        <h3 className="mt-12 font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
          Intent（日本円 → ステーブルコイン）
        </h3>
        <StatusPipeline nodes={INTENT_NODES} className="mt-6" />
        <p className="mt-4 text-xs text-muted-foreground">
          ※{" "}
          <code className="rounded bg-muted/40 px-1.5 py-0.5 font-mono text-[11px]">
            FAILED
          </code>{" "}
          は入金額不一致・ウォレット未設定・送金エラー等により遷移します。
        </p>

        <h3 className="mt-14 font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
          Redemption（ステーブルコイン → 日本円）
        </h3>
        <StatusPipeline nodes={REDEMPTION_NODES} className="mt-6" />
        <p className="mt-4 text-xs text-muted-foreground">
          ※ 期限切れ・過少/過多入金・遅延入金は{" "}
          <code className="rounded bg-muted/40 px-1.5 py-0.5 font-mono text-[11px]">
            OnHold
          </code>{" "}
          /{" "}
          <code className="rounded bg-muted/40 px-1.5 py-0.5 font-mono text-[11px]">
            Expired
          </code>{" "}
          /{" "}
          <code className="rounded bg-muted/40 px-1.5 py-0.5 font-mono text-[11px]">
            Failed
          </code>{" "}
          に遷移します。
        </p>
      </div>
    </section>
  );
}
